<template>
  <el-row :gutter="20">
    <el-col
      v-for="q in aQuotes"
      :key="q.id"
      :xs="24"
      :sm="24"
      :md="12"
      :lg="8"
      :xl="6"
    >
      <el-card type="text" class="quote_card">
        <div @click="nav(q.author.id)">
          <div slot="header" class="clearfix">
            <el-row :gutter="10" align="middle" justify="space-between">
              <el-col :span="4" v-if="q.author">
                <el-button :disabled="!$auth.isAuthenticated" type="text">
                  <ShareButton
                    v-if="$auth.isAuthenticated"
                    :url="`https://quotur.com/author/${q.author.id}`"
                    :title="`~ ${q.quote_text}\n~ ${getAuthorName(q)}`"
                    :quote="`~ ${q.quote_text}\n`"
                    hashtags="#quotur"
                  />
                </el-button>
              </el-col>
              <el-col :span="4">
                <el-button
                  :disabled="!$auth.isAuthenticated"
                  @click="fav(q)"
                  type="text"
                >
                  <i v-show="!q.favorite" class="lg el-icon-star-off"></i>
                  <i v-show="q.favorite" class="lg el-icon-star-on"></i>
                </el-button>
              </el-col>

              <el-col :span="4">
                <el-button type="text">
                  <i class="lg el-icon-link"></i>
                </el-button>
              </el-col>

              <el-col :offset="8" :span="4">
                <el-image
                  style="margin-left:12px;width:38px;height:38px;border-radius:50%;top:10px;position:relative;"
                  ref="avatar"
                  :fit="'cover'"
                  :src="getAuthorImg(q)"
              /></el-col>
            </el-row>
          </div>
          <div class="card_body">
            ~{{ q.quote_text }}<br />
            <span v-if="q.author"> ~ {{ getAuthorName(q) }}</span>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import ShareButton from "../components/ShareButton.vue";
import fav from "../mixins/fav";
import nav from "../mixins/fav";
export default {
  components: { ShareButton },
  props: {
    quotes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    author: Object
  },
  data() {
    return {
      aQuotes: [],
      imageSrc: require("../assets/default-author.png")
    };
  },
  methods: {
    async fav(q) {
      q.favorite = !q.favorite;
      await this.postFav(q.id, "quote", q.favorite);
      this.$emit("postfav");
    },
    getAuthorImg(q) {
      const i = require("../assets/default-author.png");
      if (!q.author) return i;
      return q.author.image_url || i;
    },
    getAuthorName(q) {
      return q.author.name || this.author.name;
    }
  },
  mixins: [fav, nav],
  name: "quotes",
  computed: {},
  async mounted() {
    const author = this.author;
    if (!this.author) {
      this.aQuotes = this.quotes;
    } else {
      this.aQuotes = this.quotes.map(q => {
        return {
          ...q,
          author
        };
      });
    }
  }
};
</script>
<style>
.quote_card {
  margin-bottom: 6px;
  font-size: 1.6vh;
}

.card_body {
  overflow: auto;
  height: 16vh;
}
</style>
